module.exports = __webpack_public_path__ + "static/media/D6.758139a4.png";